export default __webpack_public_path__ + "static/media/fat.18f60e0e.svg";